import { InfoRounded, WarningOutlined } from '@mui/icons-material';
import React from 'react';
import CAppTooltip from './CAppTooltip';

type CAppInfoTooltipProps = {
	title: string | JSX.Element;
	forme?: 'triangle' | 'circle';
	color?: string;
};

const CAppInfoTooltip = (props: CAppInfoTooltipProps) => {
	return (
		<span style={{ position: 'relative', margin: '0px 0px' }}>
			<CAppTooltip {...props} placement="right" arrow>
				{props.forme === 'triangle' ? (
					<WarningOutlined sx={{ height: '1.25rem' }} />
				) : (
					<InfoRounded sx={{ height: '1.25rem' }} />
				)}
			</CAppTooltip>
		</span>
	);
};

export default CAppInfoTooltip;
